import { z } from 'zod'

import { passwordField } from '@maestro/commerce-blocks/schemas/fields'
import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const changePasswordFormSchema = z.object({
  oldPassword: z.string().nonempty(m('current-password.required')).max(100),
  newPassword: z
    .string()
    .nonempty(m('new-password.required'))
    .pipe(passwordField),
})
